<template>
    <div>
        <div class="col-12 pb-5 mb-4" v-if="contentloader">
            <img src="../../assets/pageloader.svg" class="pageloader" alt="loading">
        </div>
        <div v-if="!contentloader">
            <div class="shadow card" v-if="postedVideosList.length<1">
                <div class="card-body text-center pt-5 pb-5">
                    <div class="p-5 d-flex flex-column text-center">
                        <img src="../../assets/no_video.svg" alt="novideo" class="img-md-fluid img-sm-fluid no-video pl-5 pr-5 pb-4">
                        <span class="proximanova-thin fontsize24 black60" v-if="loginuserid==getuserid">You haven't posted any Videos</span>
                        <span class="proximanova-thin fontsize24 black60" v-if="loginuserid!==getuserid && userProfileDetails && userProfileDetails.privacy == 'PRIVATE'">You are not allowed to watch user posted videos</span>
                        <button class="postingVideo proximanova btn btn-default mt-4 p-1" v-if="loginuserid==getuserid" @click="postavideomodalopen=!postavideomodalopen">Post a video</button>
                    </div>
                </div>
            </div>
            <div v-else>
                <div v-for="(videoitem, index) in postedVideosList" :key="index">
                    <div class="shadow card mb-2" :id="'postVideoCardItem'+index">
                        <div class="card-body postedvideoslist">
                            <div class="d-flex flex-column">
                                <div class="videocardhead d-flex justify-content-between p-3">
                                    <div class="d-flex">
                                        <div class="postvideoimage pl-1">
                                            <img v-if="videoitem.userDetailsVo" :src="videoitem.userDetailsVo.profilePictureLink" @error="videoitem.userDetailsVo.profilePictureLink = null" alt="profilepic" oncontextmenu="return false" class="rounded-circle border border-secondary loadingBgImg" width="40px">
                                            <!-- <img v-else  src="../../assets/Profile_placehlder.svg" alt="" width="38px"> -->
                                            <div id="profImage" class=" text-center pointer rounded-circle white" :class="videoitem.userDetailsVo.userFirstName.charAt(0)" v-else>
                                              <span class="white fontsize16 defpaddingtop text-uppercase">{{videoitem.userDetailsVo.userFirstName.charAt(0)}}</span>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column pl-2 pr-2 mt-0">
                                            <span class="fontsize14 proximanova-semibold black">{{videoitem.userDetailsVo.userFirstName}} {{videoitem.userDetailsVo.userLastname}}</span>
                                            <span class="proximanova black80 fontsize12">{{videoitem.userDetailsVo.designation}}-{{videoitem.userDetailsVo.countryName}}</span>
                                        </div>
                                        <div class="proximanova black80 fontsize12 pt-1 ml-3">
                                            <span v-if="videoitem.creationD !== null && videoitem.lastUpdatedD == null">{{new Date(videoitem.creationD) | moment("from", "now", true)}} ago</span>
                                            <span v-else>{{new Date(videoitem.lastUpdatedD) | moment("from", "now", true)}} ago</span>
                                        </div>
                                    </div>
                                    <div class="" v-if="loginuserprofileid == profileId">
                                        <img src="../../assets/horizontal_menu_icon.svg" v-popover = "{name: videoitem.moremenuname}" :id="videoitem.moremenuname" width="20px" alt="moremenu" class="more_option moreactionsmenu">
                                        <popover v-bind:name="videoitem.moremenuname" class="postvideomenu" id="postvideomenu">
                                            <div class="p-3">
                                                <div class="d-flex p-1 justify-content-between">
                                                    <span class="fontsize12 proximanova-bold black">More Actions</span>
                                                    <div class="closebtn11">
                                                        <img src="../../assets/closebtn.svg" alt="close" class="img-fluid pr-1 closebtn1" @click="closePostMoreActions(videoitem.moremenuname)">
                                                    </div>
                                                </div>
                                                <div class="d-flex p-1 pl-2 ml-1 action" @click="EditPostedVideo(videoitem, videoitem.id, index)">
                                                    <img src="../../assets/Editvideo.svg" alt="edit" class="img-fluid">
                                                    <span class="p-2 fontsize14 black80 proximanova">Edit</span>
                                                </div>
                                                <div class="d-flex p-1 pl-2 ml-1 action" @click="clickOnDeletePostVideo(videoitem)">
                                                    <img src="../../assets/Deletevideo.svg" alt="delete" class="img-fluid">
                                                    <span class="p-2 fontsize14 black80 proximanova">Delete</span>
                                                </div>
                                            </div>
                                        </popover>
                                        <div class="modal backgroundnone fade confirmmodal" :id="'deletepostVideoModal'+videoitem.id" tabindex="-1" role="dialog" aria-labelledby="deletepostVideoModalLabel" aria-hidden="true">
                                          <div class="modal-dialog " role="document">
                                            <div class="modal-content pb-2">
                                              <div class="modal-header delete-modal pb-0">
                                                <h5 class="modal-title fontsize20 black80 proximanova" id="deletepostVideoModalLabel">Are you sure you want to delete this record ?</h5>
                                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                  <span aria-hidden="true">&times;</span>
                                                </button>
                                              </div>
                                              <div class="modal-body backgroundcolorwhite modal-delete text-center">
                                                <span class="button-cancel-font borderradius20 modaldeletebtn pointer border p-2 pr-4 pl-4 proximanova" data-dismiss="modal" aria-label="Close" >No</span>
                                                <span class="button-cancel-font borderradius20 backgroundcolorblack pointer white border p-2 ml-2 pr-4 pl-4 proximanova"  @click="DeletePostedVideo(videoitem.id, index)">Yes</span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="videocardbody">                                  
                                    <!-- <span v-if="videoitem.aspectRatio">
                                        <span v-if="videoitem.aspectRatio < 1">
                                            <video oncontextmenu="return false" :src="videoitem.videoLink" height="400px" controlsList="nodownload" @loadedmetadata="postvideoMetaLoaded(videoitem, index)" @error ="postvideoLoading(index)" controls muted  class="postedvideoItem portraitvideheight" @pause="VideoPause(videoitem,index,'posted')" v-on:play="VideoPlay(videoitem,index,'posted')" :id="'postvideo'+index" preload="metadata" webkit-playsinline playsinline>                                                
                                            </video>
                                        </span>
                                        <span v-if="videoitem.aspectRatio >=1">
                                            <video oncontextmenu="return false" :src="videoitem.videoLink" controlsList="nodownload" @loadedmetadata="postvideoMetaLoaded(videoitem, index)" @error ="postvideoLoading(index)" controls muted  class="postedvideoItem" @pause="VideoPause(videoitem,index,'posted')" v-on:play="VideoPlay(videoitem,index,'posted')" :id="'postvideo'+index" preload="metadata" webkit-playsinline playsinline>                                                
                                            </video>
                                        </span>
                                    </span>
                                    <span v-else> -->
                                        <video oncontextmenu="return false" :src="videoitem.videoLink" controlsList="nodownload" @loadedmetadata="postvideoMetaLoaded(videoitem, index)" height="430px" @error ="postvideoLoading(index)" controls muted  class="postedvideoItem" @pause="VideoPause(videoitem,index,'posted')" v-on:play="VideoPlay(videoitem,index,'posted')" :id="'postvideo'+index" preload="metadata" webkit-playsinline playsinline>                                        
                                        </video>
                                    <!-- </span>                                   -->
                                </div>
                                <div class="postvideocontent p-1 pb-2 pl-3">
                                    <div class="d-flex flex-column pl-2">
                                        <span class="proximanova-bold fontsize16 black80">{{videoitem.videoTitle}}</span>
                                        <span class="proximanova fontsize14 black60">{{videoitem.videoDescription}}</span>
                                        <span class="proximanova fontsize14 blue" v-if="videoitem.hashTagList && videoitem.hashTagList.length > 0">{{videoitem.hashTagList[0].hashTag.tagText}}</span>
                                    </div>
                                </div>
                                <span v-if="currentRoute != 'selectedloginviewuserprofile'">
                                <div class="horizonline"></div>
                                <div class="d-flex p-3">
                                    <div class="d-flex ml-2">
                                        <img src="../../assets/Like.svg" alt="like" title="Like" class="postvideoIcons" v-if="videoitem.likeVideoFlag == 'N'" @click="LikePostedVideo(index, videoitem.id, videoitem.profileId, 'posted')">
                                        <img src="../../assets/Likedblue.svg" alt="like" title="Unlke" class="postvideoIcons" v-if="videoitem.likeVideoFlag == 'Y'" @click="unlikePostedVideo(index, videoitem.id, 'posted')">
                                        <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2" v-if="videoitem.noOfLikes>0">{{videoitem.noOfLikes}}</span>
                                        <span class="profiledetails fontsize12 proximanova  black60  pt-1 ml-2" v-else>00</span>
                                    </div>
                                    <div class="d-flex ml-lg-5 ml-4">
                                        <img src="../../assets/Comment.svg" alt="comment" v-if="videoitem.commentVideoFlag == 'N'" class="postvideoIcons">
                                        <img src="../../assets/Commentblue.svg" alt="comment" v-if="videoitem.commentVideoFlag == 'Y'" class="postvideoIcons">
                                        <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2" v-if="videoitem.noOfComments>0">{{videoitem.noOfComments}}</span>
                                        <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2" v-else>00</span>
                                    </div>
                                    <div class="d-flex ml-lg-5 ml-4" @click="ShareVideoModal(videoitem, 'posted')">
                                        <img src="../../assets/Share_Video.svg" alt="share" class="postvideoIcons">
                                        <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2">00</span>
                                    </div>
                                    <div class="d-flex ml-lg-5 ml-4">
                                        <img src="../../assets/Views.svg" alt="views" class="postvideoIcons">
                                        <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2" v-if="videoitem.noOfViews>0">{{videoitem.noOfViews}}</span>
                                        <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2" v-else>00</span>
                                    </div>
                                </div>
                                <div class="horizonline1"></div>
                                <div class="commentsection d-flex pt-3 pl-3 pr-3 pb-1">
                                    <div class="postvideoimage pl-2">
                                        <img v-if="profilePicLink" :src="profilePicLink" @error="profilePicLink = null" alt="profilepic" oncontextmenu="return false" class="rounded-circle loadingBgImg" width="38px">
                                        <!-- <img v-else  src="../../assets/Profile_placehlder.svg" width="38px" alt=""> -->
                                        <div id="profImage" class=" text-center pointer rounded-circle white" :class="firstname.charAt(0)" v-else>
                                          <span class="white fontsize16 defpaddingtop text-uppercase">{{firstname.charAt(0)}}</span>
                                        </div>
                                    </div>
                                    <div class="commentssection d-flex">
                                        <input type="text" v-model="videoitem.commentpostText" @keyup="videoitem.postcommentbtn = true" class="commentssectiontext proximanova black60" placeholder="Add my comment...">
                                        <img src="../../assets/commentsend.svg" width="30px" v-if="videoitem.postcommentbtn" height="25px" title="post comment" class="postcommenticon ml-1" alt="comment" @click="postComment(index, videoitem, 'posted')">
                                    </div>
                                </div>
                                <div v-if="videoitem.listOfComments">
                                    <div v-if="videoitem.listOfComments.length>0">
                                        <div v-for="(comment,cmind) in videoitem.listOfComments" :key="cmind">
                                            <div class="d-flex pt-3 pl-3 pr-3" v-if="cmind < videoitem.limit_by">
                                                <div class="postvideoimage pl-2">
                                                    <img v-if="comment.profilePictureLink" :src="comment.profilePictureLink" @error="profilePictureFailure(comment, 'comment')" oncontextmenu="return false" alt="profilepic" class="rounded-circle ml-1 loadingBgImg" width="38px">
                                                    <!-- <img v-else  src="../../assets/Profile_placehlder.svg" width="38px" alt=""> -->
                                                    <div id="profImage" class=" text-center pointer rounded-circle white" :class="comment.firstName.charAt(0)" v-else>
                                                      <span class="white fontsize16 defpaddingtop text-uppercase">{{comment.firstName.charAt(0)}}</span>
                                                    </div>
                                                </div>
                                                <div v-if="loginuserprofileid != comment.profileId" class="commentssectiontext2 pl-3 p-2">
                                                    <div class="d-flex flex-column">
                                                        <span class="fontsize12 proximanova-bold black">{{comment.firstName}} {{comment.lastName}}</span>
                                                        <span class="proximanova black80 fontsize12">{{comment.designationName}}, {{comment.country}}</span>
                                                    </div>
                                                    <span class="proximanova black60  fontsize14">{{comment.comment}}</span>
                                                </div>
                                                <div v-else class="commentssectiontext2 pl-3 p-2">
                                                    <div class="d-flex justify-content-between">
                                                        <div class="d-flex flex-column">
                                                            <span class="fontsize12 proximanova-bold black">{{comment.firstName}} {{comment.lastName}}</span>
                                                            <span class="proximanova black80 fontsize12">{{comment.designationName}}, {{comment.country}}</span>
                                                        </div>
                                                        <div>
                                                            <img src="../../assets/commentsend.svg" width="28px" height="21px" v-if="comment.iscommentchanged" class="postcommenticon mr-1" title="update comment" alt="comment" @click="updateComment(comment, videoitem)">
                                                            <img src="../../assets/Delete_Comment.svg" width="28px" height="22px" alt="delete" class="postcommenticon mt-2 mr-2" title="delete comment" @click="openDeleteCommentConfirmationmodal(cmind, comment, videoitem)">
                                                        </div>
                                                    </div>
                                                    <input type="text" class="commentssectiontext3 proximanova black60  fontsize14" v-model="comment.comment" @keyup="DisplayPostCommentUpdate(comment)">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="viewallcomments pl-5 pt-3 pb-3">
                                        <span class="pl-4 ml-3 proximanova black fontsize12" v-if="videoitem.listOfComments.length>0 && videoitem.listOfComments.length > videoitem.limit_by" @click="viewAllComments(index, 'posted')">View all Comments</span>
                                        <span class="pl-4 ml-3 proximanova black fontsize12" v-if="videoitem.listOfComments.length>3 && videoitem.listOfComments.length <= videoitem.limit_by" @click="viewLessComments(index, 'posted')">View less comments</span>
                                    </div>
                                </div>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center mt-4 pb-5" v-if="currentRoute == 'selectedloginviewuserprofile'">
                  <button class="shadow backgroundcolorblack p-1 pl-3 mb-5 mouseoverbtn2 pr-3 text-center proximanova ml-1 fontsize16 borderradius20 white" @click="navToSignInWithSelectedUser">view more...</button>
                </div>
            </div>
        </div>
        <postvideomodal v-if="postavideomodalopen" @close = "closeModal"></postvideomodal>
        <sharevideomodal v-if="shareavideomodalopen" :sharevideo="sharevideoobject" @close = "closeshareModal"></sharevideomodal>
        <updatepostmodal v-if="updatepostvideomodal" :updatevideomyvidsection="updatingVideoObj" @close= "closeupdatepostmodal"></updatepostmodal>
        <delete-comment-confirmation-modal :modalTitle="deleteCommentTitle" v-if="deletecommentconfirmationmodalopen" @CloseCommentConfirmationModal = "CloseCommentConfirmationModal"></delete-comment-confirmation-modal>
        <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal>
    </div>
</template>
<script>
import httpuserprofile from "@/js/http-userprofile.js";
import sharevideomodal from '../SharePostModal.vue'
import updatepostmodal from '../updatePostVideoModal.vue'
import postvideomodal from '../postVideoModal.vue'
import APIerrorModal from '../APIerrorpopup.vue'
import deleteCommentConfirmationModal from '../deleteCommentConfirmModal.vue'
import { bus } from "../../main";
import sessionUtils from '@/js/session-util.js'
import $ from "jquery";
import router from '../../router.js'
export default{
    components: {
    sharevideomodal,
    updatepostmodal,
    postvideomodal,
    deleteCommentConfirmationModal,
    APIerrorModal
    },
    props : ['userProfileDetails'],
    data(){
        return{
            contentloader : true,
            getuseraliasname : null,
            currentRoute : null,
            postedVideosList: [],
            instanceVidoesListflag: false,
            profilePicLink:'',
            profileId: null,
            getuserid: null,
            loginuserid : sessionUtils.getUserId(),
            loginuserprofileid : sessionUtils.getUserProfileId(),
            displayAPIerrorModal : false,
            postavideomodalopen : false,
            postedvideosoffset: 0,
            firstname: '',
            lastname: '',
            userdesignation: '',
            userdisplayCountry: '',
            userCountry: '',
            shareavideomodalopen : false,
            updatepostvideomodal : false,
            instancedataget : false,
            oneTimeNoMoreVideosMessage : false,
            deletecommentconfirmationmodalopen : false,
            selectedVideotodeletecomment : null,
            selectedcommenttodelete : null,
            selectedcommentIndex : null,
            limit : 10,
            deleteCommentTitle : "Are you sure you want to delete this comment ?",
        }
        
    },
    methods:{
      closeAPIerrorModal(){
        this.displayAPIerrorModal = false;
      },
      profilePictureFailure(comment, type) {
      if(type == 'comment') {
        comment.profilePictureLink = null;
      }
    },
    navToSignInWithSelectedUser(){
      this.$session.set("selectedUserAliasname", this.getuseraliasname)
      this.$session.set("selectedJodDetailsFromLogin", true)
      router.push({
        name : 'signin'
      })
    },
      //fetching posted videos list
    getPostedVideos : function() {
      this.instanceVidoesListflag = false
      var that = this;
      httpuserprofile.get("/userprofile/postedVideosByProfileId?profileId="+this.profileId+'&limit='+this.limit+'&offset='+this.postedvideosoffset+'&loggedInProfileId='+this.loginuserprofileid)
      .then((response) => {
        this.contentloader = false;
        if(response.data) {
          if(response.data !== 'No Posted Videos Found') {
            if(response.data.length > 9) {
              this.instanceVidoesListflag = true
            }else{
              this.oneTimeNoMoreVideosMessage = true
            }
          }else{
            console.log("not a number : ",this.instanceVidoesListflag )
          }
          response.data.forEach(function(d, index){               
            d.isPlaying = false;
            d.iscommentsopen = false;
            d.isMuted = false;
            d.postcommentbtn = false;
            d.moremenuname = 'popover'+index;
            d.limit_by = 3;
            d.videoDuration = null;
            d.videoWatched =false;
            d.videoPaused = false;
            d.videoWidth =  null;
            d.videoHeight = null;
            d.aspectRatio = null;
            if(d.listOfComments.length > 0){
              d.listOfComments.forEach(function(c){
                c.iscommentchanged = false;
              })
            }
          })
          this.postedVideosList = this.postedVideosList.concat(response.data);
          this.instancedataget = true;
          console.log("posted videos list : ", this.postedVideosList)
        }
      }).catch((e) => {
        console.log(e)
        this.contentloader = false;
        this.instancedataget = true;
        this.instanceVidoesListflag = false
      })
    },
    //this will invoke after click on closebutton on post video modal / succesfully posted a video
    closeModal() {
      this.postavideomodalopen = false;
    },
    // this will invoke after click on view all comments option in comments section to load more comments
    viewAllComments: function(index, sectionType) {
        var x = this.postedVideosList[index]
        if(x.iscommentsopen){
          x.iscommentsopen = false
        }else{
          x.iscommentsopen = true
        }
        this.postedVideosList[index].limit_by = this.postedVideosList[index].limit_by+3;
      
    },
    // this will invoke after click on view less comments option to hide the video comments
    viewLessComments : function(index, sectionType) {
        var x = this.postedVideosList[index]
        if(x.iscommentsopen){
          x.iscommentsopen = false
        }else{
          x.iscommentsopen = true
        }
        this.postedVideosList[index].limit_by = 3;
    },
    //closing moremenu popover
    closePostMoreActions : function(id) {
      // document.getElementById('postvideomenu').style.display = 'none'
      document.getElementById(id).click()
    },
    // this will invoke while modifying the comment to display update button
    DisplayPostCommentUpdate : function(comment){
      console.log(Comment)
      comment.iscommentchanged = true;
    },
    //this will invoke aftre click on update comment button to update that comment
    updateComment : function(comment, viditem) {
      console.log("comment : ", comment)
      var fd = new FormData(); 
      if(viditem.videoType === 'SHARE') {
        console.log("share type comment")
        var obj = {
          id : comment.commentId,
          profileId : this.loginuserprofileid,
          videoId: viditem.id,
          videoProfileId: viditem.sharedVideoUserDetails.profileId,
          comments: comment.comment
        }
      }
      if(viditem.videoType === 'POST') {
        console.log("post type comment")
        var obj = {
          id : comment.commentId,
          profileId : this.loginuserprofileid,
          videoId: viditem.id,
          videoProfileId: viditem.userDetailsVo.profileId,
          comments: comment.comment
        }
      }
      var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
      fd.append("userVideoComments", blob)
      httpuserprofile.put("/userprofile/updateComment", fd, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept" : "*/*"
        }
      }).then((response) => {
          console.log("comment update response : ", response)
          comment.iscommentchanged = false;
      }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
    },
    openDeleteCommentConfirmationmodal(cmind, comment, videoItem) {
      this.deletecommentconfirmationmodalopen = true;
      this.selectedcommentIndex = cmind;
      this.selectedcommenttodelete = comment;
      this.selectedVideotodeletecomment = videoItem;
    },
    CloseCommentConfirmationModal(deletecommentstatus) {
      console.log("check status 1")
      if(deletecommentstatus == 'SUCCESS'){
        console.log("api call to delete comment video", this.selectedcommentIndex)
        this.deletecommentconfirmationmodalopen = false;
        this.deletepostedVideoComment(this.selectedcommentIndex, this.selectedcommenttodelete, this.selectedVideotodeletecomment)
      }else{
        console.log("cancel delete comment")
        this.deletecommentconfirmationmodalopen = false;
        this.selectedcommentIndex = null;
        this.selectedcommenttodelete = null;
        this.selectedVideotodeletecomment = null;
      }
    },
    //deleting video comment
    deletepostedVideoComment : function(cmind, comment, videoItem) {
      httpuserprofile.delete("/userprofile/deleteCommentOnVideo?commentId="+comment.commentId)
      .then((response) => {
          console.log("delete response : ", response)
          videoItem.listOfComments.splice(cmind, 1)
          videoItem.noOfComments = videoItem.noOfComments-1
      }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
    },
    //this will invoke after click on edit button on moremenu popover to edit the user posted video
    EditPostedVideo : function(obj, videoId, index) {
      console.log("edit button clicked on posted videoItem : ", videoId)
      console.log("editing obj : ", obj)
      this.updatepostvideomodal = true;
      this.updatingVideoObj = obj;
      if(obj.videoType === 'DRAFT'){
        this.selectedDraftVideoIndex = index
      }
    },
    // removing video source if getting any error while loading the video metadata using video url 
    postvideoLoading : function(index) {
      this.postedVideosList[index].videoLink = null
    },
    //like a video
    LikePostedVideo : function(index, videoId, VideoProfId, sectionType) {
      console.log("videoId : ", videoId)
      console.log("videoprofId : ", VideoProfId)
      console.log("sectionType : ", sectionType)
      var obj = {
        profileId : this.loginuserprofileid,
        videoId : videoId,
        videoProfileId : VideoProfId
      }
      var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
      const fd = new FormData();
      fd.append('userVideoLikes', blob);
      httpuserprofile.post('/userprofile/likeVideo',fd, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then((response) => {
        console.log(response)
        //update posted video like info
        this.postedVideosList[index].likeVideoFlag = 'Y'
          this.postedVideosList[index].listOfLikes = response.data.listOfLikes
          this.postedVideosList[index].noOfLikes = response.data.noOfLikes
          console.log("liked posted video : ", this.postedVideosList[index])        
      }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
    },
    //unlike a liked video
    unlikePostedVideo : function(index, videoId, sectionType) {
      console.log("unlike videoId : ", videoId)
      httpuserprofile.delete('/userprofile/unLikesVideo?videoId='+videoId+'&profileId='+this.loginuserprofileid)
      .then((response) => {
        this.postedVideosList[index].likeVideoFlag = 'N'
          this.postedVideosList[index].noOfLikes = this.postedVideosList[index].noOfLikes - 1
      }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
    },
    //loading video mata data
    postvideoMetaLoaded(video,index){
      var videoElement = document.getElementById("postvideo"+index); 
      video.videoWidth = videoElement.videoWidth;
      video.videoHeight = videoElement.videoHeight;
      video.aspectRatio = videoElement.videoWidth/videoElement.videoHeight;
    },
    //this is onplay event to trigger the particular video
    // call an API to maintain views records if user view the video more than half of its actual duartion
    VideoPlay  :function(videoitem, index, sectionType) {      
    // console.log(videoitem)
      var video = document.getElementById("postvideo"+index);      
      videoitem.videoDuration = video.duration;
      videoitem.videoPaused = false;
      var currentTime = videoitem.videoDuration * (50/100);     
      var self= this                         
      video.ontimeupdate = function(){
        if(currentTime < video.currentTime && !videoitem.videoWatched){
          videoitem.videoWatched = true;                      
          self.viewVideo(videoitem);
        }        
       }
      video.onended = function() {
        var nextIndex = index + 1;
        var nextVideo = document.getElementById("postVideoCardItem"+nextIndex);
        if(nextVideo){
          nextVideo.scrollIntoView()
        }
      }
    },
    // view video to maintain a view record to the particualr video
    viewVideo: function(video){
      if(video.viewVideoFlag === 'N' && this.loginuserprofileid != video.profileId && this.currentRoute != 'selectedloginviewuserprofile'){
        console.log("into view function")
        var fd = new FormData(); 
          var obj = {
          profileId : this.loginuserprofileid,
          videoId: video.id,
          videoProfileId: video.profileId,
          viewed_sec : 0,
          video_type : 'POSTVIDEO'
        }
        var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
        fd.append("userVideoViews", blob)
        fd.append("duration", 1)
        httpuserprofile.post("/userprofile/viewVideo", fd, {
          headers: {
              "Content-Type": "multipart/form-data",
          }
        })
        .then(response => {
          console.log(response)
          if(response.data.errorCode === 1030){
            video.videoWatched = false
            video.isPlaying = true;
            video.viewVideoFlag = 'Y';
            video.noOfViews = video.noOfViews+1;
          }                           
        }) .catch((e) => {
          console.log(e)
        })       
      }
    },
    // posting a comment on a video
    // set the updated comments list to the actual video to display
    postComment : function(index, viditem, sectionType){
      console.log("comment on video : ", viditem)
      var fd = new FormData();
      if(viditem.videoType === 'SHARE') {
        console.log("share type comment")
        var obj = {
          profileId : this.loginuserprofileid,
          videoId: viditem.id,
          videoProfileId: viditem.sharedVideoUserDetails.profileId,
          comments: viditem.commentpostText
        }
      }
      if(viditem.videoType === 'POST') {
        console.log("post type comment")
        var obj = {
          profileId : this.loginuserprofileid,
          videoId: viditem.id,
          videoProfileId: viditem.userDetailsVo.profileId,
          comments: viditem.commentpostText
        }
      }
      var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
      fd.append("userVideoComments", blob)
      httpuserprofile.post("/userprofile/commentOnVideo", fd, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept" : "*/*"
        }
      }).then((response) => {
          console.log("comment posted vid : ", response)
            this.postedVideosList[index].commentpostText = '';
            this.postedVideosList[index].postcommentbtn = false;
            this.postedVideosList[index].commentVideoFlag = 'Y'
            response.data.listOfComments.forEach(function(c){
              c.iscommentchanged = false;
            })
            this.postedVideosList[index].listOfComments = response.data.listOfComments
            this.postedVideosList[index].noOfComments = response.data.noOfComments

      }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
    },
    // pause video
    VideoPause  :function(videoitem, index, sectionType) {
      videoitem.videoPaused = true;
    },
    //fethcing the current user information
    getUserByID(){
        httpuserprofile
        .get("/userprofile/userbyid/" + sessionUtils.getUserId())
        .then(response => {
            console.log(response)
          
          // this.getuserid = response.data.userId
          // this.profileId = response.data.profileId;
          this.firstname = response.data.firstName;
          this.lastname = response.data.lastName;
          this.profilePicLink = response.data.profilePictureLink;
          if(response.data.designation){
            this.userdesignation = response.data.designation.roleName
          }
          if(response.data.country){
            this.userdisplayCountry = response.data.country.countryName
          }
          this.userCountry = response.data.country;
          if(this.getuserid == this.loginuserid || (this.getuserid != this.loginuserid && this.userProfileDetails.privacy != 'PRIVATE')){
          this.getPostedVideos()
          }
          if(this.getuserid != this.loginuserid && this.userProfileDetails.privacy == 'PRIVATE'){
            this.contentloader = false;
          }
        }).catch((e) => {
          console.log(e)
        });
    },
    //this will invoke after click on closebutton on update video modal/ after successfully updated
    closeupdatepostmodal(returnObj) {
      this.updatepostvideomodal = false;
      console.log("close modal", returnObj)
    },
    clickOnDeletePostVideo(videoitem) {
      var id = "#deletepostVideoModal"+videoitem.id
      $(id).modal('show')
    },
    //deleting a posted video
    DeletePostedVideo : function(videoId, index) {
      console.log("delete post video id : ", videoId)
      console.log("index : ", index)
      var vm = this
      httpuserprofile.delete('/userprofile/deletePostedVideo?videoId='+videoId)
      .then((response) => {
        console.log(response)
        var id = "#deletepostVideoModal"+videoId
        $(id).modal('hide')
        this.closePostMoreActions(this.postedVideosList[index].moremenuname)
        vm.$toast.success("Successfully deleted posted video")
        this.postedVideosList.splice(index, 1)
        this.postedVideosList.forEach((video,index) =>{          
            video.moremenuname = 'popover'+index;
        })
        // this.postedVideosList.splice(index, 1)
        // this.instancedataget = false;
        // this.contentloader = true;
        // this.postedvideosoffset = 0;
        // this.postedVideosList = []
        // this.getPostedVideos()
        // this.getPostedVideos()
      }).catch((e) => {
        console.log(e)
        var id = "#deletepostVideoModal"+videoId
        $(id).modal('hide')
        this.displayAPIerrorModal = true;
      })
    },
    // closing share video modal
    closeshareModal() {
      this.shareavideomodalopen = false
    },
    // this will invoke aftre click on share button on a video card
    // open share video modal to share video
    ShareVideoModal(item, sectionType) {
      //check once
      item.currentUserProfilepic = this.profilePicLink;
      item.currentUserFirstname = this.firstname;
      item.currentUserLastname = this.lastname;
      item.currentUserDesignation = this.userdesignation;
      if(sectionType === 'posted') {
        item.videoUserId = this.profileId;
        item.videoUserFirstName = this.firstname;
        item.videoUserLastName = this.lastname;
        item.videoUserProfilePic = this.profilePicLink;
        item.videoUserDesignation = this.userdesignation;
      }else{
        item.videoUserId = item.userDetailsVo.profileId;
        item.videoUserFirstName = item.userDetailsVo.userFirstName;
        item.videoUserLastName = item.userDetailsVo.userLastname;
        item.videoUserProfilePic = item.userDetailsVo.profilePictureLink;
        item.videoUserDesignation = item.userDetailsVo.designation;
      }
      this.sharevideoobject = item
      this.shareavideomodalopen = true
    },
    //this will invoke while scrolling down to fetch more records
    // autoplay functionality
    handleScroll() {
      let scrollPosition = window.scrollY
      var self = this;         
      if(this.instancedataget) {
        if ((window.innerHeight + window.scrollY+1) >= document.body.offsetHeight) {
        
          if(this.instanceVidoesListflag) {
       
            this.postedvideosoffset += 10;
            this.instancedataget = false;
            this.getPostedVideos()
          }else{
            if(this.oneTimeNoMoreVideosMessage && this.currentRoute != 'selectedloginviewuserprofile'){
              self.$toast.success("No More Video Found")
              this.oneTimeNoMoreVideosMessage = false;
            }
          }
        }
      }

      var media;
       media = $('.postedvideoItem').not("[autoplay='autoplay']");
        autoplay()
      
      function autoplay() {
        var tolerancePixel = 100;
        var scrollTop = $(window).scrollTop() + tolerancePixel;
        var scrollBottom = $(window).scrollTop() + $(window).height() - tolerancePixel;
        var playPromise;
        media.each(function(index, el) {
          var yTopMedia = $(this).offset().top;
          var yBottomMedia = $(this).height() + yTopMedia;
          // var playVideo = $(this).get(0);
          // var vid = this.playVideo.id;
          // var vindex = vid.substr(9) ;
          if(scrollTop < yBottomMedia && scrollBottom > yTopMedia){ //view explaination in `In brief` section above                    
            playPromise = $(this).get(0).play();
            // console.log(self.postedVideosList[index].videoLink)
            if(playPromise !== undefined){
              playPromise.then(_ => {
                $(this).get(0).play();
                // console.log("checktag : ", this)
              })
              .catch(error => {
                // console.log(error)
              });
            }
          } else {
            $(this).get(0).pause();
          }
        });
      }
    },
    },
    mounted(){
        window.scrollTo(0, 0)
        this.currentRoute = this.$route.name;
        window.addEventListener('scroll', this.handleScroll); 
        this.getuserid = this.userProfileDetails.userId;
        this.profileId = this.userProfileDetails.profileId;
        if(this.currentRoute != 'selectedloginviewuserprofile'){
          this.getUserByID();  
        }else{
          this.getuseraliasname = this.$route.params.id;
          this.limit = 2;
          this.loginuserprofileid = 0;
          this.getPostedVideos()
        }
        var that = this;   
        bus.$on("successfullypostedvideo", data => {
            if(data){
              setTimeout(() => {
                that.contentloader = true;
                that.postedvideosoffset = 0;
                that.postedVideosList = [];
                that.instancedataget = false;
                that.getPostedVideos()
              }, 2000)
            }
        })   
    },
    destroyed() {
      bus.$off("successfullypostedvideo")
    window.removeEventListener('scroll', this.handleScroll);
  }
    
}
</script>
<style scoped>
.pageloader {
  width: 7%;
  margin-top: 15%;
  margin-left: 46%;
}
.more_option {
  cursor: pointer;
}
.loadingBgImg{
  background: transparent url('../../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.action {
  cursor: pointer;
}
.action:hover {
  background-color:rgba(221, 223, 229,0.4);
  border-radius: 5px;
}
.commentssectiontext3{
  /* background-color: none !important; */
}

  .commentssectiontext1{
	width: 70%;
	/* margin-left: 12% !important; */
	padding: 4px;
	padding-left: 8px;
	margin-left: 4%;
	margin-top: 2px;
	border-radius: 15px;
	border: none;
	background-color: #F0F2F5;
	color: rgba(31, 31, 31, .6);
  }
.postvideoIcons {
  cursor: pointer;
}
.horizonline{
  margin-left: 20px;
  margin-right: 20px;
  border-bottom: 1px solid #E9EBF0;
}
.horizonline1{
  border-bottom: 1px solid #E9EBF0;
}
.commentssection{
  width: 100%;
}
#profImage{
  width : 40px;
  height: 40px;
  line-height: 40px;
}
.viewallcomments {
  color: black;
  font-size: 12px;
  cursor: pointer;
}
.postcommenticon{
  margin-right: -5px;
  margin-top: 8px;
  cursor: pointer;
}
  .commentssectiontext1:focus{
	outline: none;
	box-shadow: none;
  }
  
  .commentssectiontext2{
	width: 80%;
	padding: 4px;
	padding-left: 12px;
	margin-left: 3%;
	border-radius: 0 15px 15px 15px;
	background-color: #F0F2F5;
  }
.moreactionsmenu {
	width: 25px;
	padding: 3px;
	border: 1px solid white;
  }
  .moreactionsmenu:hover{
	background-color: rgba(161, 166, 179,0.1);
	border-radius: 50%;
	border: 1px solid rgba(161, 166, 179,.5);
  }
.closebtn1{
  cursor: pointer;
  width: 15px;
  height: 15px;
  margin-top: -3px;
}
.closebtn11:hover{
  background-color: rgba(161, 166, 179,0.3);
  padding-left: 2px;
  border-radius: 50%;
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.postedvideoslist{
  padding: 0 !important;
}
.postingVideo {
  cursor: pointer; 
  text-align: center;
  border-radius: 16px;
  width: 140px;
  /* margin-left: 40%; */
  background-color: #0078ff;
  color: white !important;
  transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
  margin: auto;
}
.postingVideo::before {
	transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 16px;
	background-color :  rgba(255,255,255,.3);
}
.postingVideo:hover:before {
	transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
/* Notification Actions */
  .dropdown-position-bottom.postvideomenu {
    z-index: 3 !important;
    color: rgba(31,31,31,1)  !important;
    font-size: 12px !important;
    top: 50px !important;
    font-weight: 500;
    width: 150px !important;
    top: 7% !important;
    left: unset !important;
    /* left: 0px !important; */
    position: absolute;
    transform: translate3d(-73%, 0%, 0px)  !important;
  }
  .vue-popover.dropdown-position-bottom.postvideomenu:before {
    display: none !important;
  }
  .videocardbody {
    position: relative;
    width: 100%;
    height: 100%;
    /* //padding: 20px; */
    background-attachment: scroll;
    overflow: hidden;
    background: black;
}
.videocardbody video {
    min-width: 100%;
    min-height: 100%;
    width: 100%;
    position: relative;
    z-index: 1;
    margin-bottom: -1%;
}
.videocardbody .overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    margin-top: 0px !important;
    z-index: 2;
    background: rgba(31, 31, 31, .6);
    /* background: linear-gradient(0deg, rgba(0,0,0,0) 0%, #000000 100%); */
    /* background: linear-gradient(180deg, rgba(0,0,0,0) 0%, #000000 50%); */
    opacity: 0.5;
   
}
#postedvideoItem{
  width: 100%;
}
.confirmmodal{
  margin-top: 15%;
}
.delete-modal{
  border: none;
}
.modaldeletebtn{
  transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
}
.modaldeletebtn::before{
  transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px;
  margin-top: -1px;
	background-color :  rgba(29, 27, 27, 0.1);
}
.modaldeletebtn:hover::before{
  transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
.close{
  padding: 1px 7px 5px 7px !important;
  /* margin-top: 0px !important; */
  margin-top: -3px !important;
  margin-right: 5px !important;
}
.close:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
@media only screen and (max-width: 600px) {
  .videocardbody video{
    width: 100% !important;
  }
  .pageloader {
    width: 20%;
    margin-top: 25%;
    margin-left: 40%;
  }
}
@media screen and (min-width: 600px) {
  .no-video {
    width: 50%;
    align-self: center;
  }
}
</style>
